import firebase from 'firebase/app';
import { sendInvitationEmail } from '@/services/network/invitation';
import { SEND_INVITATION_EMAIL } from './actionTypes';

export default {
  [SEND_INVITATION_EMAIL]({ getters }, emails) {
    if (!emails.length) {
      throw new Error('Emails are empty');
    }

    const promises = emails.map((email) =>
      sendInvitationEmail(email, getters.referralLink, firebase.auth().currentUser.displayName),
    );
    return Promise.all(promises);
  },
};
